import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ComponentDataTable, DefaultModal, SimpleCenteredModal } from '../../../components';
import MassiveActions from './MassiveActions';
import {
  deleteSettlementGroupRequest,
  exportSettlementGroupRequest,
  generateSettlementGroupDocument,
  indexSettlementGroupsRequest,
  massiveDestroySettlementGroupRequest
} from '../../../requests/payrollSettlementGroup';
import ColumnsGroup from './ColumnsGroup';
import { sendAlert } from '../../../actions/utils';
import { downloadFile } from '../../../services/utils';
import SettlementDocumentForm from '../Form/SettlementDocumentForm';

const defaultModalState = {
  show: false,
  title: '',
  body: '',
  handleAction: () => {},
  disabled: false
};

const GroupTable = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [onRequest, setOnRequest] = useState(true);
  const [settlements, setSettlements] = useState([]);
  const [amount, setAmount] = useState(0);
  const history = useHistory();
  const [defaultModal, setDefaultModal] = useState(defaultModalState);
  // eslint-disable-next-line no-unused-vars
  const [allSelected, setAllSelected] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [sortColumnCase, setSortColumnCase] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [moreData, setMoreData] = useState(false);
  const [modalSize, setModalSize] = useState('lg');
  const [modalBody, setModalBody] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const dispatch = useDispatch();
  const { currentCompany } = useSelector(state => state.auth);

  const handleIndexRequest = () => {
    if (!currentCompany.id) return;
    indexSettlementGroupsRequest({
      dispatch,
      params: {
        filter_by_company: currentCompany.id,
        paginate: true,
        sort_column: 'name',
        sort_direction: 'asc'
      },
      successCallback: ({ data }) => {
        setSettlements(data.data);
        setAmount(data.metaData?.amount);
      },
      callback: () => {
        setOnRequest(false);
      }
    });
  };

  const handleSettlementDocument = (values, settlementId) => {
    generateSettlementGroupDocument(settlementId, {
      dispatch,
      params: {
        template_id: values.templatePdf.templateId,
        extra_keys: values.templatePdf.extraKeys
      },
      successCallback: () => {
        setModalShow(false);
        dispatch(sendAlert({ kind: 'success', message: 'Documento generado con éxito' }));
      },
      callback: () => {
        setMoreData(oldVal => !oldVal);
      }
    });
  };

  const handleDelete = id => {
    setDefaultModal(oldState => ({ ...oldState, disabled: true }));
    deleteSettlementGroupRequest(id, {
      dispatch,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Finiquito Grupal eliminado con éxito' }));
        setDefaultModal(oldState => ({ ...oldState, show: false }));
        setMoreData(!moreData);
      },
      failureCallback: () => {},
      callback: () => {
        setDefaultModal(oldState => ({ ...oldState, disabled: false }));
      }
    });
  };

  const handleActions = (item, action) => {
    switch (action) {
      case 'edit':
        history.push(`/settlement_simulator/group/${item.id}/edit`);
        break;
      case 'generate_document': {
        setModalTitle('Finiquito de Trabajo');
        setModalBody(<SettlementDocumentForm settlementId={item.id} formRequest={handleSettlementDocument} />);
        setModalSize('lg');
        setModalShow(true);
        break;
      }
      case 'destroy': {
        const isSimulation = item.simulation;
        const modalText = isSimulation
          ? '¿Está seguro que desea eliminar la simulación de finiquito?'
          : '¿Está seguro que desea eliminar el finiquito?';
        setDefaultModal({
          show: true,
          title: 'Eliminar Finiquito',
          body: modalText,
          handleAction: () => handleDelete(item.id)
        });
        break;
      }
      default:
        break;
    }
  };

  const handleMassiveDestroy = ids => {
    setDefaultModal(oldState => ({ ...oldState, disabled: true }));
    massiveDestroySettlementGroupRequest({
      dispatch,
      params: {
        filter_by_company: currentCompany.id,
        ...ids
      },
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Finiquitos eliminados con éxito' }));
        setDefaultModal(oldState => ({ ...oldState, show: false }));
        setMoreData(!moreData);
      },
      callback: () => {
        setDefaultModal(oldState => ({ ...oldState, disabled: false }));
      }
    });
  };

  const handleMassiveActions = action => {
    const selectedIds = selectedRows.length > 0 ? { filter_id: selectedRows.map(row => row.id) } : {};
    switch (action) {
      case 'download_excel':
        exportSettlementGroupRequest({
          dispatch,
          params: {
            filter_by_company: currentCompany.id,
            ...selectedIds
          },
          format: '.xlsx',
          successCallback: data => {
            downloadFile(data, 'finiquitos.xlsx');
          },
          callback: () => {}
        });
        break;
      case 'destroy': {
        const modalText = !Object.keys(selectedIds).length
          ? '¿Está seguro que desea eliminar todos los grupos?'
          : '¿Está seguro que desea eliminar los grupos seleccionados?';
        setDefaultModal({
          show: true,
          title: 'Eliminar Finiquito',
          body: modalText,
          handleAction: () => handleMassiveDestroy(selectedIds)
        });
        break;
      }
      default:
        break;
    }
  };

  const handleSelectedRows = item => {
    setAllSelected(item.allSelected);
    setSelectedRows(item.selectedRows);
  };

  return (
    <>
      {currentCompany.id && (
        <ComponentDataTable
          onRequest={onRequest}
          columns={ColumnsGroup(handleActions)}
          data={settlements}
          totalRows={amount}
          handleSortCase={sortColumnCase}
          moreData={moreData}
          resourceRequest={handleIndexRequest}
          preName="TableGrupal"
          withMassActions
          massActions={<MassiveActions disabled={false} handleClick={handleMassiveActions} />}
          selectableRows
          clearSelectedRows={clearSelectedRows}
          onSelectedRowsChange={handleSelectedRows}
          withDateSelect
          withStartDate
          withEndDate
        />
      )}
      <DefaultModal
        show={defaultModal.show}
        handleClose={() => setDefaultModal(oldState => ({ ...oldState, show: false }))}
        title={defaultModal.title}
        body={defaultModal.body}
        handleConfirm={defaultModal.handleAction}
        withClose
        withConfirm
        disabled={defaultModal.disabled}
      />
      <SimpleCenteredModal
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        onHide={() => setModalShow(false)}
        bodyClass="mx-3 mb-3"
        size={modalSize}
      />
    </>
  );
};

export default GroupTable;
